import type { AxiosResponse } from 'axios';
import { httpWithAuth } from '~/clients';
import { DEALERSHIP_INVENTORY, INVENTORY } from '~/constants/endpoints';
import { InventoryRequest } from '~/contracts/common';
import { InventoryResponse } from '~/services/srp/contracts';

export default function fetchInventory(
  request: InventoryRequest,
  controller: AbortController,
  headers?: Record<string, string>
): Promise<AxiosResponse<InventoryResponse>> {
  const url = request.dealershipId ? DEALERSHIP_INVENTORY : INVENTORY;

  return httpWithAuth.post<InventoryResponse>(url, request, {
    headers,
    signal: controller.signal
  });
}
